import sdkTool from "If_AdTool/common/sdkTool";
function renderFn(el, data) {
    //其他情况执行此代码    
    let city = sdkTool.cookie('city');
    if (window.location.href.indexOf("AD___PREVIEW=1") != -1 || city != '010' ){
        // 第二次打开执行以下代码
        // 这里可以添加第二次打开时的特殊逻辑
        IfengAmgr.setAdElContent({
            ap: 9060, code: JSON.stringify({
                "data": {
                    "tuid": "u7003231",
                },
                "script": "pc_bottom.js",
                "callback": "pc_bottom"
            }), el: document.body, w: 1240, h: 130, encode: false
        })

        //IfengAmgr.show
    } 
    IfengAmgr.show(el, data)
}
if (typeof window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.pvpageBottomAd = { render: renderFn, version: "1.0.1" };
}